import React from 'react';
import { graphql } from 'gatsby';
import PageWithLocalNav from '@atlaskit/gatsby-theme-brisk/src/templates/page-with-local-nav';
import HeadingContext from '@atlaskit/gatsby-theme-brisk/src/components/local-nav/heading-context';
import {
  ContextualAnalyticsData,
  SCREEN,
  FireScreenAnalytics,
} from '@atlassian/analytics-bridge';
import ContentRenderer from '../components/content-renderer';
import getSidebar from '../utils/getSidebar';
import { normalizeSourceName } from '../utils/analytics';
import titleify from '../utils/titleify';

const slugify = require('github-slugger').slug;

const GuidelinePage: React.ComponentType<{ data: Record<string, any> }> = ({
  data,
}) => {
  const imageNodes = data.allContentfulAsset.edges || [];
  const images = imageNodes.map(edge => edge && { url: edge.node.file.url });
  const guideline = data.contentfulGuideline;
  const headingsContent = guideline.bodyText.content.filter(
    node => node.nodeType === 'heading-2' || node.nodeType === 'heading-3',
  );
  const headings = headingsContent.map(heading => {
    let depth = heading.nodeType === 'heading-2' ? 2 : 3;
    return {
      depth,
      value: heading.content[0].value,
      id: slugify(heading.content[0].value),
    };
  });

  const parentPage = guideline.contentfulparent
    ? titleify(guideline.contentfulparent.slug)
    : guideline.title;
  const title = guideline.title;
  const parentPageTitle = parentPage === title ? null : parentPage;

  const sourceName = normalizeSourceName(guideline.category, guideline.title);
  const categoryName = normalizeSourceName(guideline.category);
  const context = {
    headings,
  };

  return (
    <ContextualAnalyticsData
      sourceType={SCREEN}
      sourceName="content"
      attributes={{ name: sourceName, context: categoryName }}
    >
      <HeadingContext.Provider value={context}>
        <PageWithLocalNav
          parentPageTitle={parentPageTitle}
          title={title}
          sidebar={getSidebar(guideline.category)}
          description={
            guideline.description && guideline.description.description
          }
          guidelineCategory={guideline.category}
        >
          <ContentRenderer json={guideline.bodyText.json} images={images}>
            <FireScreenAnalytics />
          </ContentRenderer>
        </PageWithLocalNav>
      </HeadingContext.Provider>
    </ContextualAnalyticsData>
  );
};

export const query = graphql`
  query($slug: String!, $images: [String]) {
    contentfulGuideline(slug: { eq: $slug }) {
      title
      contentfulparent {
        slug
      }
      category
      description {
        description
      }
      bodyText {
        json
        content {
          nodeType
          content {
            value
          }
        }
      }
    }
    allContentfulAsset(filter: { file: { url: { in: $images } } }) {
      edges {
        node {
          file {
            url
          }
        }
      }
    }
  }
`;

export default GuidelinePage;
